import {
  currentSelectedLanguage,
  storeIdentifyLeakers,
  storeTemplateIdentifyLeakers,
  storeIDLeakerLookupData,
  updateIDLeakerValue,
  updateTemplateIDLeakerValue
} from "../../../../StateManagement/actions"; import { useSelector } from "react-redux";
import useGetTabs from "../../../Pages/CommonSettings/hooks/useGetTabs";
import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, useTransition } from "react";
import { useDispatch } from 'react-redux';
import { createPortal } from "react-dom";
import { useNavigate } from 'react-router-dom';
import Alert from "../../../Controls/Alerts/Alerts";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";
function SelectField({ id, label, options, value, level, type, mode = "document", className = '', disableCipherShape = false, ...props }) {
  const dispatch = useDispatch();
  const selectedType = useRef();
  const onChangeHandler = (e) => {
    const type = selectedType.current.id;
    const level = selectedType.current.id.split('__')[1];
    if (mode === "template") {
      dispatch(updateTemplateIDLeakerValue({
        type: type.split('__')[0],
        value: e.target.value,
        level
      }));
    }
    else {
      dispatch(updateIDLeakerValue({
        type: type.split('__')[0],
        value: e.target.value,
        level
      }));
    }
  }
  return (
    <div className="mb-3 row align-items-center mx-1">
      <div className="col-sm-5">
        <label htmlFor={type} className="col-form-label font-w500 ms-3 control res-w">
          {label}
        </label>
      </div>
      <div className="col-sm-7 pe-4">
        <select
          id={`${type}__${level}`}
          className={`custom-inputBorder form-select form-control red-shadow border-r4 ${className}`}
          aria-label={label}
          value={value || ''}
          onChange={onChangeHandler}
          ref={selectedType}
          disabled={disableCipherShape}
          {...props}
        >
          {options?.map((option) => (
            <option key={option.key} value={option.key}>
              {option.keyValue}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
function InputWithSelect({
  inputId,
  selectId,
  label,
  placeholder,
  selectOptions,
  value,
  type,
  level,
  mode = "document"
}) {
  const dispatch = useDispatch();

  const inputValue = value ? value.split('-')[0] : "";
  const selectValue = value ? value.split('-')[1] : "";

  const onTextChangeHandler = (e) => {
    const newText = e.target.value.substring(0, 12);

    const payload = {
      type,
      value: newText + '-' + selectValue,
      level
    };

    if (mode === "template") {
      dispatch(updateTemplateIDLeakerValue(payload));
    } else {
      dispatch(updateIDLeakerValue(payload));
    }
  };

  const onTextBlurHandler = (e) => {
    const newText = e.target.value.trim().substring(0, 12);
    const payload = { type, value: newText + '-' + selectValue, level };
    if (mode === "template")
      dispatch(updateTemplateIDLeakerValue(payload));
    else
      dispatch(updateIDLeakerValue(payload));
  };

  const onSelectChangeHandler = (e) => {
    const newSelect = e.target.value;

    const payload = {
      type,
      value: (inputValue ? inputValue?.trim() : inputValue) + '-' + newSelect,
      level
    };

    if (mode === "template") {
      dispatch(updateTemplateIDLeakerValue(payload));
    } else {
      dispatch(updateIDLeakerValue(payload));
    }
  };

  return (
    <div className="mb-3 row align-items-center mx-1">
      <div className="col-sm-5">
        <label className="col-form-label font-w500 ms-3 control res-w">
          {label}
        </label>
      </div>

      <div className="col-sm-7 pe-4">
        <div className="input-group idliker-group red-shadow border-r4 custom-inputBorder">
          <input
            type="text"
            className="form-control"
            id={`${type}__${level}`}
            placeholder={placeholder}
            value={inputValue}
            onChange={onTextChangeHandler}
          />

          <select
            id={`${type}__${level}`}
            className="form-select"
            value={selectValue}
            onChange={onSelectChangeHandler}
            onBlur={onTextBlurHandler}
          >
            {selectOptions?.map((option) => (
              <option key={option.key} value={option.key}>
                {option.keyValue}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
const useGetCipherTextFormFields = (mode = "document") => {

  const selectedLanguage = useSelector(currentSelectedLanguage);

  const lookupData = useSelector((state) =>
    mode === "template"
      ? state.templateIdentifyLeakers.lookupData
      : state.identifyLeakers.lookupData
  );

  const cipherText = useSelector((state) =>
    mode === "template"
      ? state.templateIdentifyLeakers.cipherText
      : state.identifyLeakers.cipherText
  );

  function createCipherTextControls(id, label, settingType, type, options) {

    const value =
      cipherText?.find((item) => item.type === settingType)?.keyValue || "";

    const cipherPatternValue =
      cipherText?.find((item) => item.type === "CipherPattern")?.keyValue;

    const isShapeDisabled = cipherPatternValue !== "2";

    return {
      id,
      label,
      type,
      options,
      value: isShapeDisabled && settingType === "Shape" ? "0" : value,
      settingType,
      level: "CipherText",
      ...(isShapeDisabled && settingType === "Shape"
        ? { disableCipherShape: true }
        : {})
    };
  }

  return [
    createCipherTextControls(
      0,
      selectedLanguage.LstLanguageCodes.UI_CipherText,
      "CipherText",
      "select",
      lookupData.cipherTextOptions
    ),
    createCipherTextControls(
      1,
      selectedLanguage.LstLanguageCodes.UI_Opacity,
      "Opacity",
      "select",
      lookupData.opacityOptions
    ),
    createCipherTextControls(
      2,
      selectedLanguage.LstLanguageCodes.UI_CipherView,
      "CipherView",
      "select",
      lookupData.cipherViewOptions
    ),
    createCipherTextControls(
      3,
      selectedLanguage.LstLanguageCodes.UI_CipherPattern,
      "CipherPattern",
      "select",
      lookupData.cipherPatternOptions
    ),
    createCipherTextControls(
      4,
      selectedLanguage.LstLanguageCodes.UI_Shape,
      "Shape",
      "select",
      lookupData.shapeOptions
    ),
  ];
};
const useFloatingTextFormFields = (mode = "document") => {
  const selectedLanguage = useSelector(currentSelectedLanguage);

  const lookupData = useSelector((state) =>
    mode === "template"
      ? state.templateIdentifyLeakers.lookupData
      : state.identifyLeakers.lookupData
  );

  const floatingText = useSelector((state) =>
    mode === "template"
      ? state.templateIdentifyLeakers.floatingText
      : state.identifyLeakers.floatingText
  );

  function createFloatingTextControls(
    id,
    label,
    settingType,
    type,
    options,
    placeholder
  ) {
    const value =
      floatingText?.find((item) => item?.type === settingType)?.keyValue || "";
    // IMPORTANT FIX
    if (type === "input-with-select" && value && !value.includes("-")) {
      value = value + "-Suffix";
    }

    return {
      id,
      label,
      type,
      options,
      placeholder,
      value,
      settingType,
      level: "FloatingText"
    };
  }

  return [
    createFloatingTextControls(
      0,
      selectedLanguage.LstLanguageCodes.UI_FloatingText,
      "FloatingText",
      "select",
      lookupData.floatingTextOptions
    ),
    createFloatingTextControls(
      1,
      selectedLanguage.LstLanguageCodes.UI_SuffixPrefixFloatingText,
      "SuffixPrefixFloatingText",
      "input-with-select",
      lookupData.suffixPrefixOptions,
      selectedLanguage.LstLanguageCodes.UI_EnterText
    ),
    createFloatingTextControls(
      2,
      selectedLanguage.LstLanguageCodes.UI_Opacity,
      "Opacity",
      "select",
      lookupData.opacityOptions
    ),
    createFloatingTextControls(
      3,
      selectedLanguage.LstLanguageCodes.UI_Navigation,
      "Navigation",
      "select",
      lookupData.navigationOptions
    ),
    createFloatingTextControls(
      4,
      selectedLanguage.LstLanguageCodes.UI_FontColor,
      "FontColor",
      "select",
      lookupData.fontColorOptions
    ),
    createFloatingTextControls(
      5,
      selectedLanguage.LstLanguageCodes.UI_FontSize,
      "FontSize",
      "select",
      lookupData.fontSizeOptions
    ),
    createFloatingTextControls(
      6,
      selectedLanguage.LstLanguageCodes.UI_Speed,
      "Speed",
      "select",
      lookupData.speedOptions
    )
  ];
};
const CipherTextForm = ({ mode }) => {
  const formFields = useGetCipherTextFormFields(mode);
  return (
    <div className="idleaker-text">
      {formFields.map(field => (
        <SelectField
          key={field.id}
          id={field.id}
          label={field.label}
          options={field.options}
          value={field.value}
          type={field.settingType}
          level={field.level}
          disableCipherShape={field.disableCipherShape}
          mode={mode}
        />
      ))}
    </div>
  );
};

const FloatingTextForm = ({ mode }) => {
  const formFields = useFloatingTextFormFields(mode);
  return (
    <div className="idleaker-text">
      {formFields.map((field, index) => {
        if (field.type === 'input-with-select') {
          return (
            <InputWithSelect
              key={index}
              inputId={field.id}
              selectId={field.id}
              label={field.label}
              placeholder={field.placeholder}
              selectOptions={field.options}
              value={field.value}
              type={field.settingType}
              level={field.level}
              mode={mode}
            />
          );
        }
        return (
          <SelectField
            key={field.id}
            id={field.id}
            label={field.label}
            options={field.options}
            value={field.value}
            type={field.settingType}
            level={field.level}
            mode={mode}
          />
        );
      })}
    </div>
  )
}
const IdentifyLeakersModal = React.forwardRef(({ onClose, mode = "document" }, ref) => {
  const navigate = useNavigate();
  const documentData = useSelector((state) => state.identifyLeakers);
  const templateData = useSelector((state) => state.templateIdentifyLeakers);

  const initialIdLeakerData =
    mode === "template"
      ? (templateData || { cipherText: [], floatingText: [] })
      : documentData;
  const latestIdLeakerData = useRef(initialIdLeakerData);
  latestIdLeakerData.current = initialIdLeakerData;
  const [activeTab, setActiveTab] = useState();
  const tabs = useRef([]);
  const [isOpen, setIsOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({ cipherText: [], floatingText: [] });
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const isSave = useRef(false);
  const idLeakersType = useSelector((state) => state.idLeakers.idLeakersType
  );
  //  const idLeakersType = localStorage.getItem("IDLeakersType");
  const className = useRef("idleakers modal fade");
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();
  const { getContentSecurityTabs } = useGetTabs();
  const [isPending, startTransition] = useTransition();
  useEffect(() => {
    const { innerTabs } = getContentSecurityTabs();
    setActiveTab(innerTabs[0]?.id);
    tabs.current = innerTabs || [];
  }, [isOpen]);

  useEffect(() => {
    if (idLeakersType === "Floating Text Only") {
      setActiveTab(selectedLanguage.LstLanguageCodes.UI_FloatingTextTab);
    }
    else if (idLeakersType === "Cipher Text Only") {
      setActiveTab(selectedLanguage.LstLanguageCodes.UI_CipherTextTab);
    }
  }, [idLeakersType, selectedLanguage, isOpen]);
  // useEffect(() => {
  //    setTimeout(
  //         () => {
  //           setAlertMsg("");
  //           setAlertType("");
  //         },
  //         5000 
  //       );
  // },[alertMsg]);

  const onCloseHandler = () => {
    if (mode === "template") {
      dispatch(storeTemplateIdentifyLeakers({
        cipherText: initialValues.cipherText,
        floatingText: initialValues.floatingText
      }));
    } else {
      dispatch(storeIdentifyLeakers({
        cipherText: initialValues.cipherText,
        floatingText: initialValues.floatingText
      }));
    }
    className.current = "idleakers modal fade";
    setActiveTab(null);
    onClose(false, initialValues);
  };
  const onSaveHandler = () => {
    if (!validateCipherShape()) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_SelectCipherShape);
      setAlertType("warning");
      return;
    }
    if (mode === "template") {
      dispatch(storeTemplateIdentifyLeakers(initialIdLeakerData));
    } else {
      dispatch(storeIdentifyLeakers(initialIdLeakerData));
    }
    isSave.current = true;
    className.current = "idleakers modal fade";
    setActiveTab(null);
    onClose(false, initialValues);
  };
  function validateCipherShape() {
    const cipherPattern = initialIdLeakerData.cipherText.find(setting => setting.type === "CipherPattern");
    const cipherShape = initialIdLeakerData.cipherText.find(setting => setting.type === "Shape");
    if (cipherShape && cipherShape.keyValue === "0" && cipherPattern && cipherPattern.keyValue === "2" && idLeakersType !== "Floating Text Only") {
      return false;
    }
    return true;
  }
  useImperativeHandle(ref, () => ({
    showModal: () => {
      try {
        const currentState = latestIdLeakerData.current;
        setInitialValues({
          cipherText: currentState.cipherText,
          floatingText: currentState.floatingText
        });

        setIsOpen(true);
        setActiveTab(tabs[0]?.id);
        className.current = "idleakers modal fade show d-block";
      } catch (error) {
        console.error("Error in showModal:", error);

      }
    },
    closeModal: () => {
      setIsOpen(false);
      className.current = "idleakers modal fade";
      setActiveTab(null);
    },
  }));
  return isOpen && createPortal(
    <>
      {isPending ? <LoadingSpinner /> : null}
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
      ></Alert>
      <div className={className.current} id="myModal" style={{ zIndex: 2000 }} role="dialog">
        <div
          className="modal-dialog modal-dialog-centered modal-lg "
          style={{ zIndex: '2000 !important' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 class="d-flex align-items-center text-danger fw-bold mb-0">
                {selectedLanguage.LstLanguageCodes.UI_IDLeakers}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onCloseHandler}></button>
            </div>
            <div className="modal-body p-0">
              <div className="manageTabs-page idleaker-page">
                <ul className="nav nav-tabs" role="tablist">
                  {tabs.current.map((tab) => {
                    const isCipherTab =
                      tab.id === selectedLanguage.LstLanguageCodes.UI_CipherTextTab;
                    const isFloatingTab =
                      tab.id === selectedLanguage.LstLanguageCodes.UI_FloatingTextTab;
                    const isDisabled =
                      (idLeakersType === "Floating Text Only" && isCipherTab) ||
                      (idLeakersType === "Cipher Text Only" && isFloatingTab);
                    return (
                      <li
                        role="presentation"
                        key={tab.id}
                        className={`nav-item ${activeTab === tab.id ? "active" : ""}`}
                        onClick={() => {
                          if (isDisabled || activeTab === tab.id) return;
                          startTransition(() => {
                            setActiveTab(tab.id);
                          });
                        }}
                        style={{
                          pointerEvents: isDisabled ? "none" : "auto",
                          opacity: isDisabled ? 0.5 : 1,
                          cursor: isDisabled ? "not-allowed" : "pointer"
                        }}
                      >
                        <a
                          role="tab"
                          className={`nav-link d-flex align-items-center inner-tab ${activeTab === tab.id ? "active" : ""
                            }`}
                        >
                          <span className="material-icons font-20">
                            {tab.icontext}
                          </span>
                          <span className="ms-1">{tab.label}</span>
                        </a>
                      </li>
                    );
                  })}
                </ul>
                <div className="tab-content idLeakerScroll">
                  {tabs.current.map((tab) => {
                    const isCipherTab = tab.id === selectedLanguage.LstLanguageCodes.UI_CipherTextTab;
                    const isFloatingTab = tab.id === selectedLanguage.LstLanguageCodes.UI_FloatingTextTab;
                    const isDisabled =
                      (idLeakersType === "Floating Text Only" && isCipherTab) ||
                      (idLeakersType === "Cipher Text Only" && isFloatingTab);
                    if (isDisabled || activeTab !== tab.id) return null;
                    return (
                      <div
                        key={tab.id}
                        className="tab-pane fade show active mt-3"
                        role="tabpanel"
                      >
                        {isCipherTab && <CipherTextForm mode={mode} />}
                        {isFloatingTab && <FloatingTextForm mode={mode} />}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="modal-footer idleaker-footer">
              <button
                type="button"
                title="Cancel"
                class="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                data-bs-dismiss="modal"
                onClick={onCloseHandler}>
                Cancel
              </button>
              {mode !== "template" ? (
                <button
                  type="button"
                  title="Save"
                  class="btn btn-primary px-2 ms-1 w-140p truncate"
                  onClick={onSaveHandler}>
                  Save
                </button>
              ) : <button
                type="button"
                title="Save"
                class="btn btn-primary px-2 ms-1 w-140p truncate"
                onClick={onSaveHandler}>
                Confirm
              </button>}
            </div>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("modal-popup")
  );
})
export default IdentifyLeakersModal;
